// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body-container {\n  width: 100%; }\n  @media (min-width: 768px) {\n    .body-container {\n      min-width: 1170px; } }\n  @media (max-width: 768px) {\n    .body-container {\n      padding-top: 68px; } }\n\n.dimmed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1011;\n  background: rgba(0, 0, 0, 0.5); }\n", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 931
// module chunks = 0